import httpRequestsPaths from "@helpers/httpRequestsPaths/httpRequestsPaths";
import endpointsPaths from "../endpointsPaths/endpointsPaths";
import httpRequest from "../httpRequest";
export const getAsesoresLectura = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.getAsesoresLectura}`,
        method: "GET",
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};


export const validarAsesorLogeado = async (correo) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.validarAsesor}`,
        method: "POST",
        body: JSON.stringify({correo})
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};




export const getUsuariosByFolio = async (folioContrato) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.getUsuariosByFolio}/${folioContrato}`,
        method: "GET",
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const getUsuariosUvegRegistrados = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.obtenerUsuariosUveg}`,
        method: "POST",
      });

      resolve(grupos);
    } catch (error) {
      console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};



export const actualizarContadorGrupo = async (folioContrato, idGrupo) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.descontarEstudianteGrupo}/${idGrupo}`,
        method: "POST",
        body: JSON.stringify({folioContrato})
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};


export const obtenerEstadisticasEstudiante = async (correo) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.obtenerEstadisticas}`,
        method: "POST",
        body: JSON.stringify(correo)
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};


export const getPromedioGeneral = async (folioGrupo) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: grupos } = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.getPromedioGeneral}/${folioGrupo}`,
        method: "POST",
      });

      resolve(grupos);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const updateAvancesForoLectura = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.updateAvancesForo}`,
        method: "POST",
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};


export const recuperarExamenDiagnostico = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.getExamenDiagnosticoActivo}`,
        method: "GET",
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};


export const validateExamenRealizado = async (infoEvaluacion) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.validateEvaluacionRealizada}`,
        method: "POST",
        body: JSON.stringify(infoEvaluacion),
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};


export const guardarAvancesDiagnostico = async (infoEvaluacion) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.guardarExamenDiagnostico}`,
        method: "POST",
        body: JSON.stringify(infoEvaluacion),
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const ajustarAvanceLecturaInteligente = async (infoEvaluacion) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.ajustarAvanceLectura}`,
        method: "POST",
        body: JSON.stringify(infoEvaluacion),
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

//-------------------Competencias Lectura--------------------------

export const validarCodigoAccesoCompetencia = async (infoEvaluacion) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.validarCodigoCompetencia}`,
        method: "POST",
        body: JSON.stringify(infoEvaluacion),
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const guardarInfoParticipanteCompetencia = async (infoCompetencia) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.guardarInfoCompetencias}`,
        method: "POST",
        body: JSON.stringify(infoCompetencia),
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};



export const getResultadoFinal = async (infoUsuario) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.getResultadoFinal}`,
        method: "POST",
        body: JSON.stringify(infoUsuario),
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const guardarResultadosFinal = async (top) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.guardarResultadosFinal}`,
        method: "POST",
        body: JSON.stringify(top),
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const actualizarResultadosFinal = async (top) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.actualizarResultadosFinal}`,
        method: "POST",
        body: JSON.stringify(top),
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const getParticipantesSorteo = async (fase) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.getParticipantesSorteo}/${fase}`,
        method: "POST",
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const validarEnSemifinal = async (idPerfil) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.validarSemifinalUsuario}/${idPerfil}`,
        method: "POST",
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const validarEnFinal = async (idPerfil) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.validarEnFinal}/${idPerfil}`,
        method: "POST",
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};

export const getInfoEstudianteLectura = async (idPerfil) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await httpRequest({
        url: `${endpointsPaths.gruposLectura}/${httpRequestsPaths.gruposLectura.getInfoEstudianteLectura}/${idPerfil}`,
        method: "POST",
      });

      resolve(res);
    } catch (error) {
      // console.log("Error al obtener los grupos: ", error);

      reject(error);
    }
  });
};



//--------------------FIN COMPETENCIAS LECTURA---------------------------